import { BaseAPI } from './BaseAPI';
import { Coin, Denom, Dec, Coins, PolicyConstraints } from '../../../core';

export interface TreasuryParams {
  tax_policy: PolicyConstraints;
  reward_policy: PolicyConstraints;
  seigniorage_burden_target: Dec;
  mining_increment: Dec;
  window_short: number;
  window_long: number;
  window_probation: number;
}

export namespace TreasuryParams {
  export interface Data {
    tax_policy: PolicyConstraints.Data;
    reward_policy: PolicyConstraints.Data;
    seigniorage_burden_target: string;
    mining_increment: string;
    window_short: string;
    window_long: string;
    window_probation: string;
  }
}
export class TreasuryAPI extends BaseAPI {
  public async taxCap(denom: Denom): Promise<Coin> {
    return this.c
      .get<string>(`/treasury/tax_cap/${denom}`)
      .then(d => new Coin(denom, d.result));
  }

  public async taxRate(): Promise<Dec> {
    return this.c
      .get<string>(`/treasury/tax_rate`)
      .then(d => new Dec(d.result));
  }

  public async rewardWeight(): Promise<Dec> {
    return this.c
      .get<string>(`/treasury/reward_weight`)
      .then(d => new Dec(d.result));
  }

  public async taxProceeds(): Promise<Coins> {
    return this.c
      .get<Coins.Data>(`/treasury/tax_proceeds`)
      .then(d => Coins.fromData(d.result));
  }

  public async seigniorageProceeds(): Promise<Coin> {
    return this.c
      .get<string>(`/treasury/seigniorage_proceeds`)
      .then(d => new Coin(Denom.LUNA, d.result));
  }

  public async parameters(): Promise<TreasuryParams> {
    return this.c
      .get<TreasuryParams.Data>(`/treasury/parameters`)
      .then(d => d.result)
      .then(d => ({
        tax_policy: PolicyConstraints.fromData(d.tax_policy),
        reward_policy: PolicyConstraints.fromData(d.reward_policy),
        mining_increment: new Dec(d.mining_increment),
        seigniorage_burden_target: new Dec(d.seigniorage_burden_target),
        window_long: Number.parseInt(d.window_long),
        window_short: Number.parseInt(d.window_short),
        window_probation: Number.parseInt(d.window_probation),
      }));
  }
}
